<template>
  <highcharts style="height: 700px" :options="chartOptions" />
</template>

<script>
export default {
  props: {
    series: Array,
    categories: Array,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          polar: true,
          type: "area",
          credits: false,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.categories.map((category) =>
            this.createLabel(category)
          ),
          tickmarkPlacement: "on",
          lineWidth: 0,
        },
        series: this.series,
        tooltip: {
          formatter: function () {
            return this.point.y + " %";
          },
        },
      },
    };
  },
  methods: {
    createLabel: function (category) {
      category = category.replace(/_/g, " ").toLowerCase();
      category = category[0].toUpperCase() + category.slice(1);
      return category;
    },
  },
};
</script>
